import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import { getPayloadForCardsByLegacyId } from '@nerdwallet/nw-api-sdk/dist/offer-sdk/credit-cards';
import { createCard } from '@nerdwallet/cc-utils/lib/offer-api/offer-api';
import nrAwareErrorHandler from '../../helpers/nr-aware-error-handler';
import { setFetchingCardData } from './compare';
/**
 * Given a list of card-ids and an instance of OfferSDK, fetches the corresponding offers from the
 * offer-api, and converts them to the legacy card objects.
 *
 * @param {OfferSDK} offerSDK - An instance of OfferSDK.
 * @param {number[]} cardIDs - An array of card-ids.
 * @returns {Promise<Object[]>} - A promise that resolves into an array of cards.
 */

var getCardDataFromOfferApi = function getCardDataFromOfferApi(offerSDK, cardIDs) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
      var payload, _ref2, _ref2$data, response, offers, offersFromPayloadByLegacy;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(cardIDs && cardIDs.length)) {
                _context.next = 18;
                break;
              }

              payload = getPayloadForCardsByLegacyId(cardIDs);
              dispatch(setFetchingCardData(true));
              _context.prev = 3;
              _context.next = 6;
              return offerSDK.getCreditCards(payload.getJSON());

            case 6:
              response = _context.sent;
              dispatch(setFetchingCardData(false));
              offers = ((_ref2 = response || {}) === null || _ref2 === void 0 ? void 0 : (_ref2$data = _ref2.data) === null || _ref2$data === void 0 ? void 0 : _ref2$data.offers) || [];
              offersFromPayloadByLegacy = offers.map(function (offer) {
                return createCard(offer, payload);
              });
              return _context.abrupt("return", offersFromPayloadByLegacy);

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](3);
              nrAwareErrorHandler('Error getting data from offer-api'); // eslint-disable-next-line no-console

              console.error('Error while fetching legacy card data ', _context.t0);
              return _context.abrupt("return", []);

            case 18:
              return _context.abrupt("return", Promise.resolve([]));

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 13]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

export default getCardDataFromOfferApi;